import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { Spdr } from "../Spdr";
import { TextFieldInput } from "../../../Forms/TextFieldInput";
import { MdmFormProps } from "../../../Forms/MdmFormProps";

export const SpdrReturnForm = ({ disabledFields }: MdmFormProps) => {
  const { control } = useFormContext<Spdr>();

  return (
    <Grid container columnSpacing={3}>
      <Grid item xs={3}>
        <BorderedFormGrid>
          <Grid item xs={12}>
            <TextFieldInput
              name="ReturnMegaLdm"
              control={control}
              label="Return Mega LDM"
              disabledFields={disabledFields}
            />
          </Grid>
          <Grid item xs={12}>
            <TextFieldInput
              name="ReturnEuroLdm"
              control={control}
              label="Return Euro LDM"
              disabledFields={disabledFields}
            />
          </Grid>
          <Grid item xs={12}>
            <TextFieldInput
              name="ReturnWeight"
              control={control}
              label="Return Weight in kg"
              disabledFields={disabledFields}
            />
          </Grid>
          <Grid item xs={12}>
            <TextFieldInput
              name="ReturnCubicMeters"
              control={control}
              label="Return Cubic Meters"
              disabledFields={disabledFields}
            />
          </Grid>
        </BorderedFormGrid>
      </Grid>
    </Grid>
  );
};
